"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Menu = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../constants");
var _focus = require("../../util/focus");
var _Menu = require("./Menu.context");
var _Menu2 = require("./Menu.styles");
/**
 * Keyboard interaction is different from dropdowns in that you navigate the menu with the arrow
 * keys as opposed to with tab. Actions can be selected with enter or space.
 *
 * [ARIA Authoring Practices: Menu](https://www.w3.org/WAI/ARIA/apg/patterns/menu/)
 *
 * @extends Dropdown
 * @subcomponents ['MenuContent', 'MenuHeading', 'MenuItem', 'MenuPopper']
 * @since 7.28.0
 */
var Menu = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  var defaultInnerRef = (0, _react.useRef)();
  var innerRef = forwardedRef || defaultInnerRef;
  var activeElement = (0, _react.useRef)();
  var onBeforeTakeFocus = props.onBeforeTakeFocus,
    onClose = props.onClose;

  // Capture the original focus element so we can handle tab navigation after taking focus
  var onBeforeTakeFocusCallback = (0, _react.useCallback)(function () {
    if (typeof document !== 'undefined') {
      activeElement.current = document.activeElement;
    }
    if (onBeforeTakeFocus) {
      onBeforeTakeFocus();
    }
  }, [onBeforeTakeFocus]);
  var onKeyDownCallback = (0, _react.useCallback)(function (e) {
    if (e.keyCode === _constants.KEY_CODES.ARROW_DOWN) {
      (0, _focus.focusNextElement)(innerRef.current);
      e.preventDefault();
    } else if (e.keyCode === _constants.KEY_CODES.ARROW_UP) {
      (0, _focus.focusPreviousElement)(innerRef.current);
      e.preventDefault();
    } else if (e.keyCode === _constants.KEY_CODES.TAB) {
      // Restore focus to the trigger and let default behavior take over
      if (activeElement.current) {
        activeElement.current.focus();
      }
      if (onClose) {
        onClose();
      }
    }
  }, [innerRef, onClose]);
  return /*#__PURE__*/_react.default.createElement(_Menu.MenuContext.Provider, {
    value: {
      onActivate: onClose
    }
  }, /*#__PURE__*/_react.default.createElement(_Menu2.StyledMenu, (0, _extends2.default)({
    innerRef: innerRef
  }, props, {
    onKeyDown: onKeyDownCallback,
    onBeforeTakeFocus: onBeforeTakeFocusCallback
  })));
});
exports.Menu = Menu;
Menu.displayName = 'Menu';
Menu.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Inherited from Dialog.
   */
  onBeforeTakeFocus: _propTypes.default.func,
  /**
   * Function called when the menu should closed, e.g. when a `MenuItem` is clicked.
   *
   * Inherited from Dialog.
   */
  onClose: _propTypes.default.func,
  /**
   * Menus have the role of `"menu"` by default per the
   * [accessibility guidelines](https://www.w3.org/WAI/ARIA/apg/example-index).
   */
  role: _propTypes.default.string
} : {};
Menu.defaultProps = {
  onBeforeTakeFocus: undefined,
  onClose: undefined,
  role: 'menu'
};